import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import constant from "./utils/constant";
import { CircleWithIcon } from "./Common";
import { LinkIcon } from "../../images";
import Processing from "./Proccessing";

const LinkBox = (props) => {
  const { processing, sendUrlFunc } = props;
  const back_color = constant.COLOR.BACK_COLOR_OF_CIRCLE_HAS_ICON;
  const [isUrlValid, setUrlValidation] = useState(false);
  const [mediaUrl, setMediaUrl] = useState("");
  const goBtn = useRef(null);

  const url_is_valid = (url) => {
    const regex = new RegExp(constant.URL_REGEX);
    return regex.test(url);
  };

  const handleChangeUrl = (e) => {
    const media_url = e.target.value;
    const urlValidation = url_is_valid(media_url);
    setMediaUrl(media_url);
    setUrlValidation(urlValidation);
  };

  const handleBlurUrl = (e) => {
    const media_url = e.target.value;
    const urlValidation = url_is_valid(media_url);
    setUrlValidation(urlValidation);
  };

  const handleKeypress = (e) => {
    const key_num = e.which || e.keyCode;
    //it triggers by pressing the enter key
    if (isUrlValid && key_num === 13) {
      goBtn && goBtn.current.click();
    }
  };

  if (processing) {
    return <Processing backColor={back_color.ACTIVE_SMALL_LINK} />;
  }

  return (
    <div className="initial-state link">
      <div className="link-input-group">
        {isUrlValid ? (
          <div
            className="go"
            style={{ backgroundColor: back_color.ACTIVE_SMALL_LINK }}
            onClick={() =>
              sendUrlFunc(mediaUrl, constant.API.SERVER_TRANSCRIBE_URl)
            }
            ref={goBtn}
          >
            <span>برو</span>
          </div>
        ) : (
          <CircleWithIcon
            classNames="icon-wrapper"
            backColor={back_color.ACTIVE_SMALL_LINK}
            ChildComponent={LinkIcon}
          />
        )}
        <input
          name="media"
          type="text"
          id="media_url"
          autoFocus={true}
          placeholder="example.com/sample.mp3"
          value={mediaUrl}
          onChange={handleChangeUrl}
          onBlur={handleBlurUrl}
          onKeyPress={handleKeypress}
        />
      </div>
      <div className="text">
        <div className="in-web">
          <div>نشانی اینترنتی فایل حاوی گفتار (صوتی/تصویری) را وارد</div>
          <div>و دکمه را فشار دهید</div>
        </div>
        <div className="in-mobile">
          نشانی اینترنتی فایل گفتاری (صوتی/تصویری) را وارد کنید
        </div>
      </div>
    </div>
  );
};

LinkBox.propTypes = {
  processing: PropTypes.bool,
  sendUrlFunc: PropTypes.func.isRequired,
};

// Set default props
LinkBox.defaultProps = {
  processing: false,
};

export default LinkBox;
